<template>
  <v-row justify="center">
    <v-dialog v-model="isWindowDisplayed" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" large title="Modifier affectation">
          {{ iconAdd }}
        </v-icon>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Modification d'une affectation </span>
        </v-card-title>
        <template
          v-if="
            (isFromProjectVue &&
              new Date().getTime() < new Date(project.endDate).getTime()) ||
              !isFromProjectVue
          "
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-row class="mt-2">
                  <template v-if="isFromProjectVue">
                    <v-col class="d-flex" cols="4">
                      <v-autocomplete
                        :items="[project]"
                        v-model="projectP"
                        item-text="name"
                        item-value="id"
                        name="project"
                        label="Projet de l'affectation"
                        color="#51bdcb"
                        item-color="dark"
                        disabled
                      >
                      </v-autocomplete>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col class="d-flex" cols="4">
                      <v-autocomplete
                        :items="[resource]"
                        v-model="resourceR"
                        item-text="name"
                        item-value="id"
                        name="resource"
                        label="Resource de l'affectation"
                        color="#51bdcb"
                        item-color="dark"
                        disabled
                      >
                      </v-autocomplete>
                    </v-col>
                  </template>
                  <v-col class="d-flex" cols="8">
                    <v-autocomplete
                      :items="assignments"
                      v-model="curAss"
                      text-value="id"
                      name="resource"
                      label="Détails de l'affectation"
                      :hint="hintMessage"
                      persistent-hint
                      color="#51bdcb"
                      item-color="dark"
                    >
                      <!-- selctionné -->
                      <template slot="selection" slot-scope="{ item }">
                        <template v-if="isFromProjectVue">
                          {{ item.resource.name }} :
                          {{ new Date(item.startDate).toLocaleDateString() }} ->
                          {{ new Date(item.endDate).toLocaleDateString() }}
                        </template>
                        <template v-else>
                          {{ item.project.name }} :
                          {{ new Date(item.startDate).toLocaleDateString() }} ->
                          {{ new Date(item.endDate).toLocaleDateString() }}
                        </template>
                      </template>

                      <!-- déroulant -->
                      <template slot="item" slot-scope="{ item }">
                        <template v-if="isFromProjectVue">
                          {{ item.resource.name }} :
                          {{ new Date(item.startDate).toLocaleDateString() }} ->
                          {{ new Date(item.endDate).toLocaleDateString() }}
                        </template>
                        <template v-else>
                          {{ item.project.name }} :
                          {{ new Date(item.startDate).toLocaleDateString() }} ->
                          {{ new Date(item.endDate).toLocaleDateString() }}
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-col class="d-flex mt-10" cols="12">
                  <v-slider
                    label="Nouveau pourcentage par semaine"
                    thumb-label="always"
                    min="0"
                    max="100"
                    step="5"
                    color="#51bdcb"
                    track-color="grey"
                    v-model="percentage"
                  >
                  </v-slider>
                  <p>Pourcentage actuel : {{ curAss.percentage }}</p>
                </v-col>

                <v-col>
                  <template>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <vc-date-picker
                          show-iso-weeknumbers="left-outside"
                          v-model="dates"
                          :available-dates="{
                            start: new Date(project.startDate),
                            end: 0,
                          }"
                          mode="date"
                          is-range
                          :color="colorEtat"
                          class="mx-7"
                        >
                        </vc-date-picker>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="dateRangeStart"
                          label="Nouveau premier jour"
                          prepend-icon="mdi-calendar"
                          readonly
                          color="#51bdcb"
                        ></v-text-field>
                        <v-text-field
                          v-model="dateRangeEnd"
                          label="Nouveau dernier jour"
                          prepend-icon="mdi-calendar"
                          readonly
                          color="#51bdcb"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
                <v-col v-if="isErrorMessageDisplayed" class="col-12">
                  <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                  >
                    {{ errorMessage }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </template>
        <template v-else>
          <p class="text-center text-h6 px-auto mt-10">
            Ce projet est terminé depuis le
            {{ new Date(project.endDate).toLocaleDateString() }}.
          </p>
          <p class="text-center text-h6 px-auto pb-5">
            Modifier ses affectations n'est plus possible !
          </p>
        </template>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!curAss" color="red" text @click="deleteAssignment">
            Supprimer affectation
          </v-btn>
          <v-btn color="#51bdcb" text @click="closeWindow"> Annuler </v-btn>
          <v-btn
            :disabled="!curAss"
            color="#51bdcb"
            text
            @click="updateAssignment"
          >
            Modifier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="isErrorDisplayed"> <PopUpError /></template>
  </v-row>
</template>

<script>
import {
  UPDATE_ASSIGNMENT,
  DELETE_ASSIGNMENT,
} from '../graphql/GraphQLMutations';
import { GET_ALL_PROJECTS, GET_ALL_RESOURCES } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

const _ = require('lodash');

export default {
  name: 'ModalUpdateAss',

  props: {
    project: {
      type: Object,
      required: false,
    },
    assignments: {
      type: Array,
      required: false,
    },
    isFromProjectVue: {
      type: Boolean,
      required: true,
    },
    resource: {
      type: Object,
      required: false,
    },
  },

  components: {
    PopUpError,
  },

  data: () => ({
    isWindowDisplayed: false,
    iconAdd: 'mdi-account-edit',
    curAss: '',
    percentage: 50,
    dates: {
      start: new Date(),
      end: new Date(),
    },
    isErrorMessageDisplayed: false,
    errorMessage: '',
    hintMessage: '',
    projectP: {},
    resourceR: {},
    isErrorDisplayed: false,
  }),

  mounted() {
    if (this.project && !this.resource) {
      this.hintMessage = 'Nom de la ressource : date début -> date fin';
    } else {
      this.hintMessage = 'Nom du projet : date début -> date fin';
    }
    if (this.project) {
      this.projectP = this.project;
    }
    if (this.resource) {
      this.resourceR = this.resource;
    }
  },

  computed: {
    colorEtat() {
      if (new Date().getTime() < new Date(this.dates.end).getTime()) {
        return 'gray';
      }
      return 'red';
    },
    dateRangeStart() {
      const dateStart = this.dates.start.toISOString().slice(0, 10);
      return dateStart;
    },
    dateRangeEnd() {
      const dateEnd = this.dates.end.toISOString().slice(0, 10);
      return dateEnd;
    },
  },

  methods: {
    closeWindow() {
      this.curAss = '';
      this.errorMessage = '';
      this.percentage = 50;
      this.dates.start = new Date();
      this.dates.end = new Date();
      this.isWindowDisplayed = false;
      this.isErrorMessageDisplayed = false;
    },
    updateAssignment() {
      // reset error
      this.isErrorDisplayed = false;

      if (this.curAss) {
        if (new Date().getTime() <= new Date(this.dateRangeEnd).getTime()) {
          const ass = {
            projectID: this.curAss.project.id,
            resourceID: this.curAss.resource.id,
            startDate: this.dateRangeStart,
            endDate: this.dateRangeEnd,
            percentage: parseInt(this.percentage, 10),
            validated: false,
          };
          if (ass.projectID && ass.resourceID && ass.percentage > 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_ASSIGNMENT,
                variables: {
                  id: this.curAss.id,
                  input: ass,
                },
                update: (cache, { data: { updateAssignment } }) => {
                  const cachedProjects = cache.readQuery({
                    query: GET_ALL_PROJECTS,
                  });
                  const projectIndex = _.findIndex(
                    cachedProjects.getAllProjects,
                    {
                      id: updateAssignment.project.id,
                    }
                  );
                  if (projectIndex > 0) {
                    const projectToUpdate =
                      cachedProjects.getAllProjects[projectIndex];
                    const assignmentIndex = _.findIndex(
                      projectToUpdate.assignments,
                      {
                        id: updateAssignment.id,
                      }
                    );

                    if (assignmentIndex > 0) {
                      projectToUpdate.assignments.splice(
                        assignmentIndex,
                        1,
                        updateAssignment
                      );
                      cache.writeQuery({
                        query: GET_ALL_PROJECTS,
                        data: cachedProjects,
                      });
                    }
                  }

                  const cachedResources = cache.readQuery({
                    query: GET_ALL_RESOURCES,
                  });
                  const resourceIndex = _.findIndex(
                    cachedResources.getAllResources,
                    {
                      id: updateAssignment.project.id,
                    }
                  );
                  if (resourceIndex > 0) {
                    const resourceToUpdate =
                      cachedResources.getAllResources[resourceIndex];
                    const assignmentIndex = _.findIndex(
                      resourceToUpdate.assignments,
                      {
                        id: updateAssignment.id,
                      }
                    );

                    if (assignmentIndex > 0) {
                      resourceToUpdate.assignments.splice(
                        assignmentIndex,
                        1,
                        updateAssignment
                      );
                      cache.writeQuery({
                        query: GET_ALL_RESOURCES,
                        data: cachedResources,
                      });
                    }
                  }
                },
              })
              .then(() => {
                // Result
                this.curAss = '';
                this.errorMessage = '';
                this.percentage = 50;
                this.dates.start = new Date();
                this.dates.end = new Date();
                this.isWindowDisplayed = false;
                this.isErrorMessageDisplayed = false;
              })
              .catch(() => {
                this.isErrorDisplayed = true;
              });
          } else {
            this.errorMessage =
              "Veuillez remplir tous les champs s'il vous plaît";
            this.isErrorMessageDisplayed = true;
          }
        } else {
          this.errorMessage =
            'Affectation antérieure, impossible de la modifier !';
          this.isErrorMessageDisplayed = true;
        }
      }
    },
    deleteAssignment() {
      // reset error
      this.isErrorDisplayed = false;
      if (
        // eslint-disable-next-line no-alert
        window.confirm(
          "Voulez-vous vraiment supprimer l'affectation sélectionnée ?"
        )
      ) {
        this.$apollo
          .mutate({
            mutation: DELETE_ASSIGNMENT,
            variables: {
              id: this.curAss.id,
            },
            update: (cache, { data: { deleteAssignment } }) => {
              const cachedProjects = cache.readQuery({
                query: GET_ALL_PROJECTS,
              });
              const projectIndex = _.findIndex(cachedProjects.getAllProjects, {
                id: deleteAssignment.project.id,
              });
              if (projectIndex >= 0) {
                const projectToUpdate =
                  cachedProjects.getAllProjects[projectIndex];
                const assignmentIndex = _.findIndex(
                  projectToUpdate.assignments,
                  {
                    id: deleteAssignment.id,
                  }
                );

                if (assignmentIndex >= 0) {
                  projectToUpdate.assignments.splice(assignmentIndex, 1);
                  cache.writeQuery({
                    query: GET_ALL_PROJECTS,
                    data: cachedProjects,
                  });
                }
              }

              const cachedResources = cache.readQuery({
                query: GET_ALL_RESOURCES,
              });
              const resourceIndex = _.findIndex(
                cachedResources.getAllResources,
                {
                  id: deleteAssignment.resource.id,
                }
              );
              if (resourceIndex >= 0) {
                const resourceToUpdate =
                  cachedResources.getAllResources[resourceIndex];
                const assignmentIndex = _.findIndex(
                  resourceToUpdate.assignments,
                  {
                    id: deleteAssignment.id,
                  }
                );

                if (assignmentIndex >= 0) {
                  resourceToUpdate.assignments.splice(assignmentIndex, 1);
                  cache.writeQuery({
                    query: GET_ALL_RESOURCES,
                    data: cachedResources,
                  });
                }
              }
            },
          })
          .then(() => {
            // Result
            this.curAss = '';
            this.errorMessage = '';
            this.percentage = 50;
            this.dates.start = new Date();
            this.dates.end = new Date();
            this.isWindowDisplayed = false;
            this.isErrorMessageDisplayed = false;
          })
          .catch(() => {
            this.isErrorDisplayed = true;
          });
      }
    },
  },

  watch: {
    // get current dates
    curAss(newAssignment, oldAssignment) {
      if (newAssignment && newAssignment !== oldAssignment) {
        this.dates = {
          start: new Date(newAssignment.startDate),
          end: new Date(newAssignment.endDate),
        };
        this.percentage = newAssignment.percentage;
      }
    },
  },
};
</script>
